module.exports = __webpack_public_path__ + "static/0b8d7363-1f4c-48bc-acd0-5ce805100725-7470d7938619c1485d696f58f6c38ea9.webp";